import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult =
  objectOf({
    best_action_lift: number,
    personalized_lift: number,
    random_reward: number,
    best_reward: number,
    personalized_reward: number,
  }) as (
    value: unknown
  ) => value is GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult;
